import { bemClassBuilder } from '@vista-digital/bem-class-builder'
import type { Site } from '@vista-digital/ocapi-types/v1'
import type { SitePickerDisplayText } from '@vista-digital/occ-ui'
import { SitePickerSearchForm } from '@vista-digital/occ-ui/src/lib/components/site-picker/subcomponents/search-form'
import { SitePickerSelectedSiteList } from '@vista-digital/occ-ui/src/lib/components/site-picker/subcomponents/selected-site-list'
import type { FC } from 'react'

export interface SearchFormWrapperProps {
    allSites: Site[]
    sitePickerDisplayText: SitePickerDisplayText
    setFilteredSites: (filteredSites?: Site[] | undefined) => void
    setSearchTerm: (searchTerm: string) => void
    selectedSites: Site[]
    handleSelectedSiteClicked: (siteId: string) => void
    sitesToBeDisplayed: Site[]
    allSitesSelected: boolean
    siteCountLabel: string
}
const b = bemClassBuilder('v-site-picker')

const SearchFormWrapper: FC<SearchFormWrapperProps> = props => {
    return (
        <div className={`v-site-picker ${b.element('wrapper')}`}>
            <SitePickerSearchForm
                sites={props.allSites}
                displayText={props.sitePickerDisplayText}
                onResultsChanged={props.setFilteredSites}
                onSearchTermChanged={props.setSearchTerm}
            />
            <SitePickerSelectedSiteList
                sites={props.selectedSites}
                onSiteClicked={props.handleSelectedSiteClicked}
                removeSelectedSiteIconName={'cross'}
            />
            {(props.sitesToBeDisplayed.length > 0 || props.allSitesSelected) && (
                <span className={b.element('site-count')}>{props.siteCountLabel}</span>
            )}
        </div>
    )
}

export default SearchFormWrapper
